/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchItem
 */
export interface BatchItem {
    /**
     * 
     * @type {string}
     * @memberof BatchItem
     */
    batch?: string;
    /**
     * 
     * @type {Date}
     * @memberof BatchItem
     */
    bestBefore?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BatchItem
     */
    productionDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof BatchItem
     */
    quantityBooked?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BatchItem
     */
    isSelected?: boolean;
}

/**
 * Check if a given object implements the BatchItem interface.
 */
export function instanceOfBatchItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BatchItemFromJSON(json: any): BatchItem {
    return BatchItemFromJSONTyped(json, false);
}

export function BatchItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'bestBefore': !exists(json, 'bestBefore') ? undefined : (new Date(json['bestBefore'])),
        'productionDate': !exists(json, 'productionDate') ? undefined : (new Date(json['productionDate'])),
        'quantityBooked': !exists(json, 'quantityBooked') ? undefined : json['quantityBooked'],
        'isSelected': !exists(json, 'isSelected') ? undefined : json['isSelected'],
    };
}

export function BatchItemToJSON(value?: BatchItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch': value.batch,
        'bestBefore': value.bestBefore === undefined ? undefined : (value.bestBefore.toISOString()),
        'productionDate': value.productionDate === undefined ? undefined : (value.productionDate.toISOString()),
        'quantityBooked': value.quantityBooked,
        'isSelected': value.isSelected,
    };
}

